import {Injectable} from '@angular/core';
import {HttpClient, HttpEvent, HttpParams, HttpRequest} from '@angular/common/http';
import {BlockModel} from '../model/block.model';
import {QuestionInfo, QuestionInfoChatItem} from '../model/question.model';
import {UserAnswerMode} from '../model/user-answer.mode';
import {CHAT_CONFIG,PROFILE_CONFIG} from '../config/api';
import {Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class ChatService {
  chatKindKey = 'kind';

  constructor(private http: HttpClient) {
  }

  setChatKind(kind) {
    sessionStorage.setItem(this.chatKindKey, kind)
  }

  getChatKind() {
    return sessionStorage.getItem(this.chatKindKey);
  }

  setLastScreen(showThanks, showAbout){
    sessionStorage.setItem('showThanks', showThanks);
    sessionStorage.setItem('showAbout', showAbout);
  }

  getLastScreen(){
    return {'showThanks':sessionStorage.getItem('showThanks'), 'showAbout':sessionStorage.getItem('showAbout')};
  }

  getSteps() {
      return this.http.post(CHAT_CONFIG.getQuestionSteps, {});
  }

  getChat(categoryId) {
      return this.http.post(CHAT_CONFIG.getQuestions, {categoryId:categoryId});
  }

  // getChat(groupId) {
  //   return this.http.post(CHAT_CONFIG.getQuestions, {groupId});
  // }


  removeAnswer(id) {
    return this.http.post(CHAT_CONFIG.removeAnswer, {id: id});
  }

  setAnswer(answer: UserAnswerMode) {
    return this.http.post(CHAT_CONFIG.saveAnswer, answer);
  }

  getInitialBlock() {
    return this.http.get<any[]>(`api/quiz/profile/questions`);
  }


  setProfileInfo(data: {}) {
    return this.http.post(PROFILE_CONFIG.savePersonalInfo, data);
  }

  getProfileInfo() {
    return this.http.get<any>(PROFILE_CONFIG.getPersonalInfo);
  }

    getProfileAvatar(){
        return this.http.get<any>(PROFILE_CONFIG.getProfileAvatar);
    }

  // setProfileAvatar({image}){
  //   return this.http.post<any>(PROFILE_CONFIG.saveProfileAvatar, {image});
  // }

  uploadFile(file: File, token): Observable<HttpEvent<any>> {

    const formData = new FormData();
    formData.append('image', file);
    formData.append('token', token);

    const params = new HttpParams();

    const options = {
      params: params,
      reportProgress: true,
    };

    const req = new HttpRequest('POST', PROFILE_CONFIG.saveProfileAvatar, formData, options);
    return this.http.request(req);
  }
  
  setGuestInfo(data: {}) {
    return this.http.post(PROFILE_CONFIG.saveGuestInfo, data);
  }
  
  getGuestInfo() {
    return this.http.get<any>(PROFILE_CONFIG.getGuestInfo);
  }

  getAnswer(data: any){
    return this.http.post(CHAT_CONFIG.getAnswer, data);
  }
}
